// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5 } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  invoiceNo: string,
};

const CancelInvoice = (props: Props) => {
  const {
    visible,
    close,
    submit,
    invoiceNo,
  } = props;

  const cancelInvoice = () => {
    submit();
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      onOk={cancelInvoice}
      onCancel={() => close()}
      okText="Cancel Invoice"
      okButtonProps={{ shape: 'round', type: 'danger' }}
      cancelButtonProps={{ shape: 'round', ghost: true, type: 'primary' }}
      title="Cancel Invoice"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to cancel this invoice?</div>
        <SpH5 className="pb-3">
          <div>INVOICE # {invoiceNo}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default CancelInvoice;
